<script>
  import { getContext } from "svelte";
  export let message;
  export let onCancel = () => {};
  export let onOkay = () => {};

  const { close } = getContext("simple-modal");

  let value;
  let onChange = () => {};

  function _onCancel() {
    onCancel();
    close();
  }

  function _onOkay() {
    onOkay(value);
    close();
  }

  $: onChange(value);
</script>

<style>
  h2 {
    font-size: 2rem;
    text-align: center;
  }

  input {
    width: 100%;
  }

  .buttons {
    display: flex;
    justify-content: space-between;
  }

  .close {
    position: absolute;
    top: -2rem;
    right: 0;
    background: black;
  }
</style>

<button class="close" on:click={_onOkay}>Close</button>

<h2>{message}</h2>

<div class="buttons">
  <button class="button is-danger" on:click={_onCancel}>
    Yes, I wish to close this record
  </button>
  <button class="button is-danger is-light" on:click={_onOkay}>
    No, return to record
  </button>
</div>
